import { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";
// import { loginUser } from "../../services/auth/AuthAPI";O
import { Form, Spin } from "antd";
import TranscribeLogo from "../../../assets/img/logo.png";
import WilliamColorLogo from "../../../assets/img/williams_lea.png";
import { forgotPasswordSubmit, loginUser } from "../../../services/auth/AuthAPI";

function ForgotPasswordSubmitPage(props: any) {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [error, setError] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    localStorage.clear();
  }, []);
  const formItemLayout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
  };

  const onFinish = async (values: any) => {
    try {
      setLoading(true);
      await forgotPasswordSubmit(values.email, values.confirmationCode, values.password);
      setLoading(false);
      navigate("/");
    } catch (error: any) {
      setError(error.message);
      setLoading(false);
    }
  };

  return (
    <div className="login-main-container container-fluid justify-content-center align-item-center overflow-auto">
      <Spin spinning={loading}>
        <div className="login-container">
          <div className="login-wrapper">
            <img
              className="mb-3"
              src={TranscribeLogo}
              alt="Transcribe"
            />

            <div className="forgot-password-title">Reset Password</div>
            <Form
              {...formItemLayout}
              onFinish={onFinish}
              colon={false}
              form={form}
              style={{ width: "100%" }}>
              <Form.Item
                label="Email"
                name={"email"}
                required={false}
                rules={[{ required: true, message: "Please input your username!" }]}
                labelAlign="left">
                <input
                  type="text"
                  autoComplete="none"
                  className="form-control"
                />
              </Form.Item>
              <Form.Item
                label="Confirmation Code"
                name={"confirmationCode"}
                required={false}
                rules={[{ required: true, message: "Please input your confirmation code!" }]}
                labelAlign="left">
                <input
                  type="text"
                  className="form-control"
                />
              </Form.Item>

              <Form.Item
                label="Password"
                name={"password"}
                required={false}
                rules={[{ required: true, message: "Please input your password!" }]}
                labelAlign="left">
                <input
                  type="password"
                  className="form-control"
                />
              </Form.Item>

              <Form.Item
                label="Confirm Password"
                name={"confirmPassword"}
                required={false}
                rules={[
                  { required: true, message: "Please confirm your password!" },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error("The two passwords that you entered do not match!"));
                    },
                  }),
                ]}
                labelAlign="left">
                <input
                  type="password"
                  className="form-control"
                />
              </Form.Item>
            </Form>

            <div className="d-flex flex-column w-100">
              <span
                className="mb-3"
                style={{ color: "red", width: "100%" }}>
                {error}
              </span>
              <button
                className="button"
                style={{ justifySelf: "center", alignSelf: "center" }}
                onClick={() => form.submit()}>
                Send Code
              </button>
            </div>
            <div
              className="link my-3"
              onClick={() => navigate("/")}>
              Back to Sign in
            </div>

            <img
              className="mt-3"
              src={WilliamColorLogo}
              alt="Williams Lea"
            />
          </div>
        </div>
      </Spin>
    </div>
  );
}

export default ForgotPasswordSubmitPage;
